<div class="spacing--margin-horizontal spacing--margin-top">
  <form [formGroup]="form">
    <div class="spacing--margin-bottom">
      <span class="text--small text--h5 label">
        {{ 'feed-profit.settings.baseline-settings.prices-label' | translate }}
      </span>
      <div class="flex--column spacing--margin-top">
        <mat-form-field class="flex__child--auto">
          <span matTextPrefix class="spacing--padding-half-right">{{ currencySymbol }}</span>
          <mat-label>{{
            'feed-profit.settings.baseline-settings.price-lt-25kg' | translate
          }}</mat-label>
          <input
            matInput
            agrNumber
            [step]="0.01"
            placeholder="{{ 'feed-profit.settings.baseline-settings.price-lt-25kg' | translate }}"
            data-test="feedprofit-settings__price-lt-25kg"
            formControlName="calculatedPriceLessThan25Kg"
          />
        </mat-form-field>
      </div>
      <div class="flex--column">
        <mat-form-field class="flex__child--auto">
          <span matTextPrefix class="spacing--padding-half-right">{{ currencySymbol }}</span>
          <mat-label>{{
            'feed-profit.settings.baseline-settings.price-gt-25kg' | translate
          }}</mat-label>
          <input
            matInput
            agrNumber
            [step]="0.01"
            placeholder="{{ 'feed-profit.settings.baseline-settings.price-gt-25kg' | translate }}"
            data-test="feedprofit-settings__price-gt-25kg"
            formControlName="calculatedPriceLargerThan25Kg"
          />
        </mat-form-field>
      </div>
      <div class="flex--column">
        <mat-form-field class="flex__child--auto">
          <mat-label>{{
            'feed-profit.settings.baseline-settings.weight-per-dead-growfinisher' | translate
          }}</mat-label>
          <input
            matInput
            agrNumber
            [step]="0.01"
            placeholder="{{
              'feed-profit.settings.baseline-settings.weight-per-dead-growfinisher' | translate
            }}"
            data-test="feedprofit-settings__weight-per-dead-growfinisher"
            formControlName="averageWeightPerDeadGrowFinisher"
          />
        </mat-form-field>
      </div>
      <mat-divider></mat-divider>

      <div class="spacing--margin-vertical" *ngIf="calculation">
        <span class="text--small text--h5 label">
          {{ 'feed-profit.settings.baseline-settings.growth-procedure-label' | translate }}
        </span>
        <div class="spacing--margin-top flex--row flex--nowrap">
          <div class="flex--column">
            <mat-form-field class="flex__child--auto">
              <mat-label>{{
                'feed-profit.settings.baseline-settings.growth-start-procedure' | translate
              }}</mat-label>
              <input
                matInput
                agrNumber
                [step]="0.01"
                placeholder="{{
                  'feed-profit.settings.baseline-settings.growth-start-procedure' | translate
                }}"
                data-test="feedprofit-settings__growth-start-procedure"
                formControlName="growthStartProcedure"
              />
            </mat-form-field>
          </div>
          <div class="flex--column spacing--margin-horizontal">
            <span class="text--small text--gray label">
              {{ 'feed-profit.settings.baseline-settings.growth-norm' | translate }}
            </span>
            <span class="text--small text--bold label">
              {{ constants.baselineSettings.growthStartNorm }}
            </span>
          </div>
          <div class="flex--column spacing--margin-horizontal">
            <span class="text--small text--gray label">
              {{ 'feed-profit.settings.baseline-settings.growth-difference' | translate }}
            </span>
            <span class="text--small text--bold label">
              {{
                calculateGrowthDifference(
                  true,
                  form.controls.growthStartProcedure.value,
                  calculation
                )
              }}
            </span>
          </div>
        </div>
        <div class="spacing--margin-top flex--row flex--nowrap">
          <div class="flex--column">
            <mat-form-field class="flex__child--auto">
              <mat-label
                >{{ 'feed-profit.settings.baseline-settings.growth-end-procedure' | translate }}
                {{
                  calculation?.genders
                    ? ('feed-profit.genders.' + calculation?.genders | translate)
                    : ''
                }}</mat-label
              >
              <input
                matInput
                agrNumber
                [step]="0.01"
                placeholder="{{
                  'feed-profit.settings.baseline-settings.growth-end-procedure' | translate
                }} {{ 'feed-profit.genders.' + calculation?.genders | translate }}"
                data-test="feedprofit-settings__growth-end-procedure"
                formControlName="growthEndProcedure"
              />
            </mat-form-field>
          </div>
          <div class="flex--column spacing--margin-horizontal">
            <span class="text--small text--gray label">
              {{ 'feed-profit.settings.baseline-settings.growth-norm' | translate }}
            </span>
            <span class="text--small text--bold label" *ngIf="calculation?.genders === 'boar_gilt'">
              {{ constants.baselineSettings.growthEndNorm_boar_gilt }}
            </span>
            <span
              class="text--small text--bold label"
              *ngIf="calculation?.genders === 'barrow_gilt'"
            >
              {{ constants.baselineSettings.growthEndNorm_barrow_gilt }}
            </span>
          </div>
          <div class="flex--column spacing--margin-horizontal">
            <span class="text--small text--gray label">
              {{ 'feed-profit.settings.baseline-settings.growth-difference' | translate }}
            </span>
            <span class="text--small text--bold label">
              {{
                calculateGrowthDifference(
                  false,
                  form.controls.growthEndProcedure.value,
                  calculation
                )
              }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
